import {AdditiveBlending, Color, ShaderMaterial} from "three";

const vertexShader = `

#include <common>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <clipping_planes_pars_vertex>

varying vec3 vViewPosition;
varying vec3 vNormal;

void main()
{
    #include <skinbase_vertex>

    #include <beginnormal_vertex>
    #include <morphnormal_vertex>
    #include <skinbase_vertex>
    #include <skinnormal_vertex>
    #include <defaultnormal_vertex>

    #include <begin_vertex>
    #include <morphtarget_vertex>
    #include <skinning_vertex>
    #include <project_vertex>

    #include <clipping_planes_vertex>
    
    vViewPosition = -mvPosition.xyz;
    vNormal = transformedNormal;
}

`;

const fragmentShader = `

#include <common>
#include <dithering_pars_fragment>
#include <clipping_planes_pars_fragment>

uniform vec3 color;
uniform float fresnelPower;
uniform float exposure;

varying vec3 vViewPosition;
varying vec3 vNormal;

void main()
{
    #include <clipping_planes_fragment>

    vec3 viewDir = normalize(vViewPosition);
    vec3 normal = normalize(vNormal);
    float nDotV = 1.0 - abs(dot(viewDir, normal));
    float fresnel = pow(nDotV, fresnelPower);
    gl_FragColor = vec4(color, fresnel * exposure);     
    
    #include <tonemapping_fragment>
    #include <encodings_fragment>
}

`;

export default class FresnelMaterial extends ShaderMaterial
{
    constructor(color)
    {
        super({
            uniforms: {
                color: {
                    value: new Color(color || 0x80ccff)
                },
                exposure: {
                    value: 1.5
                },
                fresnelPower: {
                    value: 3
                }
            },
            fragmentShader,
            vertexShader,
            transparent: true,
            // side: DoubleSide,
            depthWrite: false,
            blending: AdditiveBlending
        });
    }
}